import axios from "axios";
import {
  MissionPostRequestBody,
  MissionsMissionidPutRequestBody,
} from "../components/common/type/type";
import env from "../components/common/config/env";

import mission from "../components/mock/mission.json";
import missions from "../components/mock/missions.json";

export const getMissionDetail = async (missionId: string) => {
  if (env.useMock) {
    console.log(mission);
    return mission;
  }
  try {
    const response = await axios.get(`${env.url}/v1/missions`, {
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer YOUR_TOKEN`, // 認証が必要なら追加
      },
      withCredentials: true,
    });
    const missions = response.data;
    // missionIdで該当データを抽出
    const missionDetail = Array.isArray(missions)
      ? missions.find((m: any) => m.mission.id === missionId)
      : null;

    return missionDetail?.mission || null;
  } catch (error: any) {
    console.error("Error fetching mission detail:", error);
    return null;
  }
};

export const deleteMission = async (missionId: string) => {
  if (env.useMock) {
    console.log(`Mock delete for missionId: ${missionId}`);
    return { success: true };
  }
  try {
    const response = await axios.delete(`${env.url}/v1/missions/${missionId}`, {
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer YOUR_TOKEN`, // 認証が必要なら追加
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("Error response:", error.response.data);
    } else if (error.request) {
      console.error("Error request:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    throw error;
  }
};

export const createMission = async (missionData: MissionPostRequestBody) => {
  try {
    const response = await axios.post(`${env.url}/v1/mission`, missionData, {
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer YOUR_TOKEN`, // 認証が必要なら追加
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("Error response:", error.response.data);
    } else if (error.request) {
      console.error("Error request:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    throw error; // ここでcatchに投げる
  }
};

export const editMission = async (
  missionId: string,
  missionData: MissionsMissionidPutRequestBody
) => {
  if (env.useMock) {
    console.log(mission);
    return mission;
  }
  try {
    const response = await axios.put(
      `${env.url}/v1/missions/${missionId}`,
      missionData,
      {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer YOUR_TOKEN`, // 認証が必要なら追加
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("Error response:", error.response.data);
    } else if (error.request) {
      console.error("Error request:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
  }
};

// --- 旧getMissions関数（コメントアウト） ---

export const getMissions = async (
  timeperiodFrom?: string,
  timeperiodTo?: string,
  missionTypeId?: string
) => {
  if (env.useMock) {
    console.log(missions);
    return missions;
  }

  try {
    const response = await axios.get(`${env.url}/v1/missions`, {
      params: {
        timeperiodFrom,
        timeperiodTo,
        ...(missionTypeId && { missionTypeId }),
      },
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer YOUR_TOKEN`, // 認証が必要なら追加
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("Error response:", error.response.data);
    } else if (error.request) {
      console.error("Error request:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    return null;
  }
};

export const deliveryMission = async (missionId: string) => {
  try {
    const response = await axios.post(
      `${env.url}/v1/point_manage_missions`,
      null, // POSTボディはnullで送信
      {
        params: { missionId }, // missionIdをクエリパラメータで送信
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer YOUR_TOKEN`, // 認証が必要なら追加
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("Error response:", error.response.data);
    } else if (error.request) {
      console.error("Error request:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    return null;
  }
};
